// 酒店
const state = {
  searchParams: {}, // 查询参数
  detailParams: {}, // 详情页面参数
  fillParams: {}, // 订单填写页面参数
  num: {}, // 数量
  confirmParams: {} // 订单确认页面参数
}
const getters = {
  hotelSearchParams: state => state.searchParams,
  hotelDetailParams: state => state.detailParams,
  hotelFillParams: state => state.fillParams,
  num: state => state.num,
  hotelConfirmParams: state => state.confirmParams
}
const mutations = {
  setHotelSearchParams (state, data) {
    state.searchParams = data || {}
  },
  setHotelDetailParams (state, data) {
    state.detailParams = data || {}
  },
  setHotelFillParams (state, data) {
    state.fillParams = data || {}
  },
  setNum (state, data) {
    state.num = data || {}
  },
  setHotelConfirmParams (state, data) {
    state.confirmParams = data || {}
  }
}
export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/hotelStore.js